// hooks/usePermissions.jsx
import { useAuth } from './useAuth';

export const usePermissions = () => {
    const { user, isProfessional, isSupervisor, isManager } = useAuth();

    const canManageUsers = isSupervisor || isManager;
    const canManageCompanies = isSupervisor || isManager;
    const canManageActas = isProfessional || isSupervisor || isManager;
    const canViewMetricas = isManager;
    
    // Permisos más específicos si es necesario
    const canCreateActas = isProfessional || isSupervisor || isManager;
    const canEditActas = isSupervisor || isManager;
    const canDeleteActas = isSupervisor || isManager;
    const canExportMetricas = isManager;

    return {
        canManageUsers,
        canManageCompanies,
        canManageActas,
        canViewMetricas,
        canCreateActas,
        canEditActas,
        canDeleteActas,
        canExportMetricas,
        // Permisos basados en roles específicos
        isProfessional,
        isSupervisor,
        isManager,
        userRole: user?.role
    };
};